import React, { useState } from "react";

import { Field } from "formik";
import { X } from "phosphor-react";
import RNImageUploader from "react-images-upload";

import StringHelper from "~/helpers/StringHelper";
import Button from "~/admin/components/Button";
import { getInputClassName } from "~/admin/components/Input";

export default function ImageUploader({
  name,
  maxFileSize = 5242880, // 5Mb
  actualUrl,
  helpText,
  className,
}) {
  const [base64, setBase64] = useState(null);

  const onDrop = (pictureFiles, pictureDataURLs, form) => {
    setBase64(pictureDataURLs[0]);
    form.setFieldValue(name, pictureFiles[0] ?? null);
  };

  const onDelete = (form) => {
    setBase64(null);
    form.setFieldValue(name, null);
  };

  const getErrorSize = () => {
    let max = maxFileSize / 1048576;
    return `Image trop lourde (${max} Mo max)`;
  };

  const imageSrc = StringHelper.isNullOrEmpty(base64)
    ? StringHelper.isNullOrEmpty(actualUrl)
      ? null
      : actualUrl
    : base64;

  return (
    <Field name={name}>
      {({ form, meta }) => {
        return (
          <div
            className={`${getInputClassName(meta, className)} px-0 py-0 m-0`}
          >
            <div className="flex flex-row items-center columns-2">
              <div className="flex flex-col justify-center content-center w-full">
                <RNImageUploader
                  withIcon
                  singleImage
                  withLabel={false}
                  name={name}
                  buttonText="Choisir une image"
                  fileSizeError={getErrorSize()}
                  onChange={(pictureFiles, pictureDataURLs) => {
                    onDrop(pictureFiles, pictureDataURLs, form);
                  }}
                  onDelete={() => onDelete(form)}
                  imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".svg"]}
                  maxFileSize={maxFileSize}
                  fileContainerStyle={{ boxShadow: "none" }}
                />
              </div>
              {!StringHelper.isNullOrEmpty(imageSrc) && (
                <div className="flex flex-col w-full h-max">
                  <div className="flex border-gray-500 p-2 bg-slate-300 rounded-r-lg justify-center content-center">
                    <img
                      src={imageSrc}
                      className="object-contain h-48 w-56"
                      alt="img uploader"
                    />
                    {!StringHelper.isNullOrEmpty(base64) && (
                      <div className="-ml-10 -mt-1">
                        <Button
                          color="danger"
                          size="s"
                          onClick={() => onDelete(form)}
                        >
                          <X size={14} weight="bold" />
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {helpText && <span>{helpText}</span>}
          </div>
        );
      }}
    </Field>
  );
}
